import { Controller } from "stimulus"

export default class extends Controller {

  static values = {
    indexUrl: String
  };

  connect() {
  }

  onItemPerPageChange(e) {
    e.preventDefault();
    const value = e.target.value;
    const url = new URL(window.location.href);
    url.searchParams.set('items', value);
    // Also reset page to 1 when changing items per page to avoid out of range issues
    url.searchParams.delete('page');
    location.replace(url.toString());
  }
}
